import { useColyseus } from "@/hooks/useColyseus.js";
import { useOnlinePlayers } from "@/hooks/useOnlinePlayers";

/**
 * Debug panel to visualize Colyseus connection state
 * Only shows when URL has #dev hash
 */
export function ColyseusDebugPanel() {
  const colyseus = useColyseus();
  const { onlinePlayers, usingMockData, hasWebSocketConnection } =
    useOnlinePlayers();

  // Only show if URL has #dev hash
  if (typeof window !== "undefined" && window.location.hash !== "#dev") {
    return null;
  }

  if (!colyseus) {
    return (
      <div
        style={{
          position: "fixed",
          bottom: 10,
          right: 10,
          background: "#ff0000",
          color: "white",
          padding: "10px",
          borderRadius: "5px",
          fontSize: "12px",
          zIndex: 9999,
          maxWidth: "300px",
        }}
      >
        <strong>⚠️ Colyseus Context NULL</strong>
        <div>Provider não inicializado ou fora do contexto</div>
      </div>
    );
  }

  const { connected, connectionAttempted, lastError, lobbyState } = colyseus;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 10,
        right: 10,
        background: connected ? "#22c55e" : "#ef4444",
        color: "white",
        padding: "10px",
        borderRadius: "5px",
        fontSize: "12px",
        zIndex: 9999,
        maxWidth: "300px",
        fontFamily: "monospace",
      }}
    >
      <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
        🎮 Colyseus Status
      </div>
      <div>Connected: {connected ? "✅ YES" : "❌ NO"}</div>
      <div>Attempted: {connectionAttempted ? "YES" : "NO"}</div>
      <div>WS Active: {hasWebSocketConnection ? "YES" : "NO"}</div>
      <div>Using Mocks: {usingMockData ? "YES" : "NO"}</div>
      {lastError && (
        <div style={{ color: "#fca5a5", marginTop: "5px" }}>
          Error: {lastError}
        </div>
      )}
      <div
        style={{
          marginTop: "5px",
          borderTop: "1px solid white",
          paddingTop: "5px",
        }}
      >
        <div>Online Players: {lobbyState?.onlinePlayers?.length || 0}</div>
        <div>Active Tables: {lobbyState?.tables?.length || 0}</div>
        <div>Messages: {lobbyState?.messages?.length || 0}</div>
      </div>
      <div
        style={{
          marginTop: "5px",
          borderTop: "1px solid white",
          paddingTop: "5px",
        }}
      >
        <div>Hook Players: {onlinePlayers.length}</div>
        <div style={{ fontSize: "10px", opacity: 0.8, marginTop: "3px" }}>
          {onlinePlayers
            .slice(0, 3)
            .map((p) => p.username)
            .join(", ")}
          {onlinePlayers.length > 3 && ` +${onlinePlayers.length - 3}`}
        </div>
      </div>
    </div>
  );
}
